import styled from "styled-components";

export const StyledContainer = styled.div`
  padding: 0 10px;
  margin: 0 auto;

  @media (min-width: 1100px) {
    padding: 0 20px;
  }
`;

export const StyledAlertBox = styled.div`
  text-align: center;
  padding: 18px;
  border: 1px solid red;
  background: rgba(200, 50, 50, 0.1);
  font-style: italic;
  position: relative;
  margin: 0 0 20px;

  p {
    font-size: 13px;
  }

  button.closebtn {
    border: 1px solid rgb(200, 50, 50);
    color: rgb(200, 50, 50);
    cursor: pointer;
    display: block;
    font-size: 14px;
    font-weight: 700;
    line-height: 1;
    margin: 0;
    outline: none;
    padding: 3px 6px;
    position: absolute;
    right: 10px;
    text-transform: uppercase;
    top: 10px;
  }
`;

export const StyledUIGrid = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  @media (min-width: 1600px) {
    flex-direction: row;
  }

  div.left-side,
  div.right-side {
    width: 100%;

    @media (min-width: 1600px) {
      width: calc(50% - 10px);
    }
  }

  div.left-side {
    h1 {
      font-size: 1.5rem;
    }
  }

  div.right-side {
    padding: 0;
  }
`;

export const StyledBorderBox = styled.div`
  border: 1px solid #999;
  padding: 1rem;
`;

export const StyledDivider = styled.hr`
  margin: 24px 0 14px;
  background: rgba(50, 50, 50, 0.3);
  height: 1px;
  border: none;
`;
